const Marquee = ({ text }) => (
  <div className="relative border-y border-ember/30 bg-ember/5 py-4 overflow-hidden" data-testid="editorial-marquee">
    <div className="marquee-track font-mono2 text-xs sm:text-sm tracking-[0.35em] uppercase text-ember">
      <span className="pr-8">{text.repeat(3)}</span>
      <span className="pr-8">{text.repeat(3)}</span>
    </div>
  </div>
);

export default Marquee;
